export default "__VITE_ASSET__oJysQoMX__"